module.exports = __webpack_public_path__ + "img/singletrack-study-analyst.9e4b546b.png";